import { render, staticRenderFns } from "./upcoming-workflow.vue?vue&type=template&id=7a087db4"
import script from "./upcoming-workflow.vue?vue&type=script&lang=js"
export * from "./upcoming-workflow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports